import React from "react";
import TitlePage from "../../../../app/Title/TitlePage/TitlePageView";
import Grid from "@material-ui/core/Grid";
import {Button} from "primereact/button";
import Paper from "@material-ui/core/Paper";
import LinearProgress from "@material-ui/core/LinearProgress";
import Divider from "@material-ui/core/Divider";
import NumberFormat from "react-number-format";
import {price} from "../../../../utils/formatters/Numbers";
import SubtitleLabel from "../../../../app/Title/SubtitleLabel/SubtitleLabelView";
import {InputText} from "primereact/inputtext";
import PropTypes from 'prop-types';
import {Dropdown} from "primereact/dropdown";

const AddBilateralBidAdmin = ({...props}) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                {props.messagesGrowl}
                <Grid container spacing={1}>
                    <Grid item xs={8}>
                        <TitlePage title="Bilaterales \ Posturas Administrativas \ Crear Postura"/>
                    </Grid>
                    <Grid item xs={4}>
                        <div style={{textAlign: 'right'}}>
                            <Button
                                label="Cancelar"
                                className="p-button-secondary"
                                onClick={props.handleCancel}/>&nbsp;
                            <Button
                                label="Guardar"
                                disabled={props.isLoading}
                                onClick={props.addBilateralOrderAdmin}/>
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        <Divider/>
                    </Grid>
                    <Grid item xs={12}>
                        <div className="p-grid">
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Prestamista" isBold={true}/>
                                <Dropdown name="bilateralLenderObj"
                                          options={props.catBilateralLender}
                                          filterBy="shortName"
                                          optionLabel="shortName"
                                          placeholder="Seleccione..."
                                          onChange={props.saveDataBidAdmin}
                                          value={props.bidAdmin.bilateralLenderObj}
                                />
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Prestatario" isBold={true}/>
                                <Dropdown name="bilateralBorrowerObj"
                                          options={props.catBilateralBorrower}
                                          filterBy="shortName"
                                          optionLabel="shortName"
                                          placeholder="Seleccione..."
                                          onChange={props.saveDataBidAdmin}
                                          value={props.bidAdmin.bilateralBorrowerObj}
                                />
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">&nbsp;</div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Cuenta" isBold={true}/>
                                <InputText name="account"
                                           placeholder={"Ex: AAAA999999XYZ"}
                                           maxLength={50}
                                           value={props.bidAdmin.account}
                                           onChange={props.saveDataBidAdmin}/>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Emisora" isBold={true}/>
                                <Dropdown name="instrumentObj"
                                          options={props.catInstrument}
                                          filterBy="composeName"
                                          optionLabel="composeName"
                                          placeholder="Seleccione..."
                                          onChange={props.saveDataBidAdmin}
                                          value={props.bidAdmin.instrumentObj}
                                />
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">&nbsp;</div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Titulos" isBold={true}/>
                                <NumberFormat
                                    name="titles"
                                    autoComplete='none'
                                    value={props.bidAdmin.title}
                                    thousandSeparator={true}
                                    allowNegative={false}
                                    decimalScale={0}
                                    maxLength={17}
                                    onChange={props.saveDataBidAdmin}
                                    placeholder="Ex: 99,99"
                                    customInput={InputText}/>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Tasa" isBold={true}/>
                                <NumberFormat
                                    name="rate"
                                    autoComplete='none'
                                    value={props.bidAdmin.rate}
                                    allowNegative={false}
                                    decimalScale={2} id={9} maxLength={12}
                                    onChange={props.saveDataBidAdmin}
                                    placeholder="Ex: 99,99"
                                    customInput={InputText}/>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">&nbsp;</div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Fecha Valor" isBold={true}/>
                                <SubtitleLabel header={props.bidAdmin.fecValor} />

                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Precio" isBold={true}/>
                                <SubtitleLabel header={price(props.bidAdmin.price24Hours)} />
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Importe" isBold={true}/>
                                <SubtitleLabel header={props.bidAdmin.amount}/>
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </Paper>
        </React.Fragment>
    )
};

export default AddBilateralBidAdmin;

AddBilateralBidAdmin.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    bidAdmin: PropTypes.object.isRequired,
    catBilateralLender: PropTypes.array.isRequired,
    catBilateralBorrower: PropTypes.array.isRequired,
    catInstrument: PropTypes.array.isRequired,
    addBilateralOrderAdmin: PropTypes.func.isRequired,
    handleCancel: PropTypes.func.isRequired,
    saveDataBidAdmin: PropTypes.func.isRequired,
    messagesGrowl: PropTypes.object.isRequired,
};

